export default "__VITE_ASSET__BFtSyUTo__"